import type { HistorySegment } from '@cht/shared'
import type { CountryHouseDB } from '../db.js'

export class HistoryCache {
  constructor(private readonly propertyId: string, private readonly database: CountryHouseDB) {}

  async read(from: number, to: number, userId?: string): Promise<{ segments: HistorySegment[]; cachedAt: number } | undefined> {
    const entry = await this.database.historyCache.get(this.key(from, to, userId))
    return entry ? { segments: entry.segments, cachedAt: entry.cachedAt } : undefined
  }

  async write(from: number, to: number, segments: HistorySegment[], userId?: string): Promise<void> {
    await this.database.historyCache.put({
      id: this.key(from, to, userId), propertyId: this.propertyId, userId: userId ?? 'all', from, to,
      cachedAt: Date.now(), segments
    })
  }

  private key(from: number, to: number, userId?: string): string {
    return `${this.propertyId}:${userId ?? 'all'}:${from}:${to}`
  }
}
